import { View, Text, StyleSheet, TouchableOpacity } from 'react-native'
import { AntDesign } from '@expo/vector-icons'

// styles
import { colorPalette, globalStyles } from '../../static/styles/global'

// components
import Card from '../shared/card/Card'
//translation
import { useTranslation } from 'react-i18next'

// types
type ScheduleNoteProps = {
  toggleModal: () => void
  note: string
  mode?: 'add' | 'edit'
}

const AddScheduleNote = ({
  toggleModal,
  note,
  mode = 'add'
}: ScheduleNoteProps): JSX.Element => {
  const { t } = useTranslation()
  return (
    <Card narrow>
      <View
        style={[
          globalStyles.flexOne,
          globalStyles.hDirection,
          globalStyles.hBetweenItems,
          mode === 'add' ? globalStyles.vCenterItems : globalStyles.vStartItems
        ]}
      >
        <View>
          <View
            style={[
              globalStyles.flexOne,
              globalStyles.hDirection,
              globalStyles.vCenterItems
            ]}
          >
            <Text
              style={[
                globalStyles.text,
                globalStyles.fwBold,
                globalStyles.fs15,
                globalStyles.primaryTextColor,
                globalStyles.mr1
              ]}
            >
              {t('addschedulenote')}
            </Text>
            <Text
              style={[
                globalStyles.text,
                globalStyles.fs12,
                globalStyles.primaryTextColor
              ]}
            >
              {t('optionals')}
            </Text>
          </View>
          <Text
            style={[
              globalStyles.text,
              globalStyles.fs12,
              globalStyles.grayTextColor
            ]}
          >
            {note?.length > 0 ? note : t(`(Ex: Fall Semester Schedule)`)}
          </Text>
        </View>
        <TouchableOpacity onPress={toggleModal}>
          {mode === 'add' ? (
            <AntDesign
              name="pluscircleo"
              size={24}
              color={colorPalette.secondary}
            />
          ) : (
            <Text
              style={[
                globalStyles.text,
                globalStyles.fs12,
                globalStyles.secondaryTextColor
              ]}
            >
              {t('editnote')}
            </Text>
          )}
        </TouchableOpacity>
      </View>
    </Card>
  )
}

const styles = StyleSheet.create({})

export default AddScheduleNote
